/* eslint-disable */
// AuthProvider.js
import React, { createContext, useContext, useState } from "react";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig_os, oidcConfig_ms } from "../../oidcConfigs";

const LDAAuthContext = createContext();

export const LDAAuthProvider = ({ children }) => {
  const [oidcConfig, setOidcConfig] = useState(JSON.parse(localStorage.getItem("selectedIdentityProvider")) == "microsoft" ? oidcConfig_ms : oidcConfig_os);
  const [key, setKey] = useState(0);

  const selectConfig = (config) => {
    setOidcConfig(config);
    setKey(key + 1);
  };
  const getConfig = (config) => {
      return oidcConfig;
    };

    return (
    <LDAAuthContext.Provider value={{ selectConfig, getConfig }}>
      {oidcConfig ? (
        <AuthProvider {...oidcConfig} key={key}>{children}</AuthProvider>
      ) : (
        children
      )}
    </LDAAuthContext.Provider>
  );
};

export const useLDAAuth = () => useContext(LDAAuthContext);
